import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DownloadOverlay } from '../player/components/DownloadOverlay';
const DEFAULT_PREVENT_MESSAGE = "";
/**
 * Standalone download overlay used for file types that aren't video,
 * audio, image, PDF, comment stream, or text. Thin wrapper over the
 * shared `DownloadOverlay` component (also used inside HekatePlayer /
 * HekateImageViewer), sized to fill its host container.
 */
const HekateDownloadOverlay = React.memo(function HekateDownloadOverlay(props) {
    const { fileTitle, fileSize, fileTypeName, iconUrl, downloadUrl, preventDownload, preventDownloadMessage, width, height, } = props;
    const containerStyle = {
        width: '100%',
        height: '100%',
        flex: '1 1 auto',
        position: 'relative',
        textAlign: 'center',
    };
    return (_jsx("div", { id: "player_container", style: containerStyle, children: _jsx(DownloadOverlay, { visible: true, message: preventDownloadMessage || DEFAULT_PREVENT_MESSAGE, canDownload: !preventDownload, downloadUrl: downloadUrl || undefined, title: fileTitle, fileTypeName: fileTypeName, fileSize: fileSize, fileIconUrl: iconUrl }) }));
});
export default HekateDownloadOverlay;
